import { Component, Input, OnChanges, OnDestroy } from '@angular/core';
import { AmplitudeService } from '@inyova/inyova-shared';
import { Customer, CustomerAccount } from '@inyova/models';

import { select, Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as fromAppRoot from '@app/app.reducers';
import * as fromReporting from '@reporting/reporting.reducers';

import { ReportEndValues } from '@shared/models/Reporting';
import { TrackingService } from '@shared/services/tracking.service';

@Component({
  selector: 'app-reporting-transaction-section',
  templateUrl: './reporting-transaction-section.component.html',
  styleUrls: ['./reporting-transaction-section.component.scss'],
  standalone: false
})
export class ReportingTransactionSectionComponent implements OnDestroy, OnChanges {
  private readonly onDestroy$ = new Subject<void>();

  @Input() customer: Customer;
  @Input() currentAccount: CustomerAccount;

  data = [];
  endValues: ReportEndValues;
  laterReimbursement: boolean;
  showMoneyPromotionNote: boolean;

  loading = true;

  constructor(
    private store: Store,
    private trackingService: TrackingService,
    private amplitudeService: AmplitudeService
  ) {
    this.store.pipe(select(fromReporting.selectTransactionsUpdated), takeUntil(this.onDestroy$)).subscribe((values) => {
      this.data = [...values.slice(0, 6)];
      this.loading = false;
    });
    this.store.pipe(select(fromReporting.selectEndValues), takeUntil(this.onDestroy$)).subscribe((endValues) => {
      if (!endValues || !endValues.end_date) {
        return;
      }
      this.endValues = endValues;
    });
    this.store.pipe(select(fromAppRoot.selectShowMoneyPromotionNote), takeUntil(this.onDestroy$)).subscribe((value) => {
      this.showMoneyPromotionNote = value;
    });
  }

  ngOnChanges(): void {
    this.laterReimbursement = this.currentAccount.converted_after_deadline && this.currentAccount.kind === '3a';
  }

  track(event: string): void {
    this.trackingService.trackActivity(event);
    this.amplitudeService.trackEvent('Transactions Opened', { kind: this.currentAccount.kind });
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }
}
